/**
 * Represents the types of rebate group claims in the system.
 */
export enum RebateGroupAggregatorClaimTypeModel {
	/**
	 * Represents a claim type in which both Medical and Pharmacy claims are applicable.
	 */
	All = 1,
	/**
	 * Represents a rebate group claim type specific to medical claims.
	 */
	Medical = 2,
	/**
	 * Represents a rebate group claim type specific to pharmacy claims.
	 */
	Pharmacy = 3
}
